import script from "./AccordionTumorBoard.vue?vue&type=script&setup=true&lang=js"
export * from "./AccordionTumorBoard.vue?vue&type=script&setup=true&lang=js"

import "./AccordionTumorBoard.vue?vue&type=style&index=0&id=2f671114&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f671114"]])

export default __exports__